import moment from 'moment'
import currencyFormatter from 'currency-formatter'

let duration_format = 'd'

let dateFormatter = (date) =>
  (
    moment(date).format('LL')
  )

dateFormatter.calendarDate = (date) => 
  (
    moment(date).calendar()
  )

dateFormatter.relativeDate = (date) => 
  (
    moment(date).fromNow(date)
  )


let daysFromNow = (date) => 
  (
    moment().diff(moment(date), 'days')
  )

let currency = (value) =>
{
  return currencyFormatter.format(value, {code: 'USD'})
}

let duration = (value) =>
{
  return moment.unix(value).diff(moment.unix(0), duration_format)
}

let taskStatus = (value) => { 
  switch(value)
  {
  case 'STARTED_AHEAD_OF_SCHEDULE': return 'Started, ahead of schedule'
  case 'STARTED_BEHIND_SCHEDULE': return 'Started, behind schedule'
  case 'COMPLETE': return 'Complete'
  case 'NOT_STARTED_BEHIND_SCHEDULE': return 'Not started, behind schedule'
  case 'NOT_STARTED_ON_SCHEDULE': return 'Not started, on schedule'
  default:
    throw Error('Invalid Task Status')
  }
}

export {dateFormatter, daysFromNow, currency, duration, taskStatus}


// WEBPACK FOOTER //
// ./src/etc/formatters.js